import { ComponentProps } from 'react';
import { DropdownMenuItems } from '@alltrails/denali/components/DropdownMenu';
import PaddingAwarePopup from '../../PaddingAwarePopup';
import { CustomRouteWaypoint } from '../../../types/CustomRoute';
import { getPOIPopupOffset } from '../../POI/POIResults/getPOIPopupOffset';
import styles from './WaypointContextMenu.module.scss';

type WaypointContextMenuProps = {
  options: ComponentProps<typeof DropdownMenuItems>['options'];
  waypoint: CustomRouteWaypoint;
};

const WaypointContextMenu = ({ options, waypoint }: WaypointContextMenuProps) => {
  return (
    <PaddingAwarePopup
      closeButton={false}
      closeOnClick={false}
      focusAfterOpen={false}
      latitude={waypoint.latitude}
      longitude={waypoint.longitude}
      offset={getPOIPopupOffset(false)}
      maxWidth="327"
      preferTopAnchor
    >
      <div className={styles.container}>
        <DropdownMenuItems options={options} />
      </div>
    </PaddingAwarePopup>
  );
};

export default WaypointContextMenu;
